export function formTracking() {
  const contactForm = document.querySelector('.js-submitForTracking--inquiry');
  if (contactForm) {
    contactForm.addEventListener('submit', () => {
      let identify = 'not_set';
      const formField = contactForm.querySelector('.js-formKey');
      if (formField instanceof HTMLInputElement) {
        identify = formField.value;
      }

      // contact_request
      (<any>window).dataLayer = (<any>window).dataLayer || [];
      (<any>window).dataLayer.push({
        'event': 'form_submit',
        'param_element': 'contact_request',
        'param_identify': identify,
      });
    });
  }

  const tradeShowForm = document.querySelector('.js-tradeShowFormTracking');
  if (tradeShowForm) {
    tradeShowForm.addEventListener('submit', () => {
      // ticket_request
      (<any>window).dataLayer = (<any>window).dataLayer || [];
      (<any>window).dataLayer.push({
        'event': 'form_submit',
        'param_element': 'ticket_request',
        'param_identify': 'tradeshow',
      });
    });
  }
}
